require('./bootstrap');

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // Scroll to Top
    var scrollToTopBtn = document.getElementById('top');
    var rootElement = document.documentElement;

    function scrollToTop() {
        rootElement.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    if (scrollToTopBtn) {
        scrollToTopBtn.addEventListener('click', scrollToTop);
    }

    var rootElement = document.documentElement

    function handleScroll() {
        var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
        if ((rootElement.scrollTop / scrollTotal ) > 0.80) {
            scrollToTopBtn.classList.add('active');
        } else {
            scrollToTopBtn.classList.remove('active');
        }
    }

    document.addEventListener('scroll', handleScroll);

    // Menu
    $(document).on('click', '.menu-icon', function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
    });

    // Sticky Header / Nav
    $(window).scroll(function() {
        pinHeader();
    });
    pinHeader();

    function pinHeader() {
        var sticky = $('header + nav'),
            scroll = $(window).scrollTop();

        if (scroll >= $('header').outerHeight()) {
            sticky.addClass('fixed').next().css('margin-top', sticky.outerHeight());
        } else {
            sticky.removeClass('fixed').next().attr('style', '');
        }
    }

    // People
    $('.people:not(.featured) .person').on('click', function(e) {
        e.preventDefault();
        $('.overlay').addClass('active').data('target', '.person-modal');
        $('.person-modal').addClass('active');
        $('.person-modal .person').html($(this).children().clone());
    });

    $('.person-modal .close').on('click', function(e) {
        e.preventDefault();

        $('.overlay, .person-modal').removeClass('active');

        setTimeout(function() {
            $('.person-modal .person').empty();
        }, 300);
    });

    $('.overlay.active').on('click', function() {
        $tar = $(this).data('target');
        $(this).add($tar).removeClass('active');
    });

    var slideWrapper = $('.main-slider'),
        iframes = slideWrapper.find('.embed-player'),
        lazyImages = slideWrapper.find('.slide-image'),
        lazyCounter = 0;

    // POST commands to YouTube or Vimeo API
    function postMessageToPlayer(player, command) {
        if (player == null || command == null) return;
        player.contentWindow.postMessage(JSON.stringify(command), '*');
    }

    // When the slide is changing
    function playPauseVideo(slick, control) {
        var currentSlide, slideType, startTime, player, video;

        currentSlide = slick.find('.slick-current');
        slideType = currentSlide.attr('class').split(' ')[1];
        player = currentSlide.find('iframe').get(0);
        startTime = currentSlide.data('video-start');

        if (slideType === 'vimeo') {
            switch (control) {
                case 'play':
                    if ((startTime != null && startTime > 0) && !currentSlide.hasClass('started')) {
                        currentSlide.addClass('started');
                        postMessageToPlayer(player, {
                            'method': 'setCurrentTime',
                            'value': startTime
                        });
                    }
                    postMessageToPlayer(player, {
                        'method': 'play',
                        'value': 1
                    });
                break;
                case 'pause':
                    postMessageToPlayer(player, {
                        'method': 'pause',
                        'value': 1
                    });
                break;
            }
        } else if (slideType === 'youtube') {
            switch (control) {
                case 'play':
                    postMessageToPlayer(player, {
                        'event': 'command',
                        'func': 'mute'
                    });
                    postMessageToPlayer(player, {
                        'event': 'command',
                        'func': 'playVideo'
                    });
                break;
                case 'pause':
                    postMessageToPlayer(player, {
                        'event': 'command',
                        'func': 'pauseVideo'
                    });
                break;
            }
        } else if (slideType === 'video') {
            video = currentSlide.children('video').get(0);
            if (video != null) {
                if (control === 'play') {
                    video.play();
                } else {
                    video.pause();
                }
            }
        }
    }

    // Resize player
    function resizePlayer(iframes, ratio) {
        if (!iframes[0]) return;
        var win = $('.main-slider'),
            width = win.width(),
            playerWidth,
            height = win.height(),
            playerHeight,
            ratio = ratio || 16 / 9;

        iframes.each(function () {
            var current = $(this);
            if (width / ratio < height) {
                playerWidth = Math.ceil(height * ratio);
                current.width(playerWidth).height(height).css({
                    left: (width - playerWidth) / 2,
                    top: 0
                });
            } else {
                playerHeight = Math.ceil(width / ratio);
                current.width(width).height(playerHeight).css({
                    left: 0,
                    top: (height - playerHeight) / 2
                });
            }
        });
    }

    // DOM Ready
    $(function () {
        // Initialize
        slideWrapper.on('init', function (slick) {
            slick = $(slick.currentTarget);
            setTimeout(function () {
                playPauseVideo(slick, 'play');
            }, 1000);
            resizePlayer(iframes, 16 / 9);
        });
        slideWrapper.on('beforeChange', function (event, slick) {
            slick = $(slick.$slider);
            playPauseVideo(slick, 'pause');
        });
        slideWrapper.on('afterChange', function (event, slick) {
            slick = $(slick.$slider);
            playPauseVideo(slick, 'play');
        });
        slideWrapper.on('lazyLoaded', function (event, slick, image, imageSource) {
            lazyCounter++;
            if (lazyCounter === lazyImages.length) {
            lazyImages.addClass('show');
            // slideWrapper.slick('slickPlay');
            }
        });

        //start the slider
        slideWrapper.slick({
            // fade:true,
            autoplaySpeed: 4000,
            lazyLoad: 'progressive',
            speed: 1000,
            arrows: false,
            dots: true,
            cssEase: 'cubic-bezier(0.87, 0.03, 0.41, 0.9)'
        });
    });

    // Resize event
    $(window).on('resize.slickVideoPlayer', function () {
      resizePlayer(iframes, 16 / 9);
    });

    // Positive message timeout
    setTimeout(function() {
        $('.message.positive').animate({
            height: 'toggle',
            opacity: 'toggle'
        }, 500);
    }, 5000);

    // Accordion
    if ($('.toggle .toggle-title').hasClass('active')) {
        $('.toggle .toggle-title.active').closest('.toggle').find('.toggle-inner').show();
    }

    $('.toggle .expander').on('click', function() {
        let $title = $(this).parents('.toggle-title'),
            $inner = $(this).closest('.toggle').find('.toggle-inner');

        if ($title.hasClass('active')) {
            $title.removeClass('active');
            $inner.slideUp(250);
        } else {
            $title.addClass('active');
            $inner.slideDown(250);
        }
    });

    // Default Slick Slider
    $('.default-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 4000
    });

    // Convert .svg image to SVG format (add class="svg")
    $('img.svg').each(function() {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }

            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);
        }, 'xml');
    });

    $('input.flatpickr').each(function () {
        var enableTime = $(this).data('enable-time') || false;
        var noCalendar = $(this).data('no-calendar') || false;
        var dateFormat = $(this).data('date-format');
        var altInput = $(this).data('alt-input');
        var altFormat = $(this).data('alt-format');
        var monthSelectorType = $(this).data('month-selector-type') || 'static';
        var yearSelectorType = $(this).data('year-selector-type') || 'static';

        flatpickr($(this)[0], {
            monthSelectorType: monthSelectorType,
            yearSelectorType: yearSelectorType,
            enableTime: enableTime,
            noCalendar: noCalendar,
            dateFormat: dateFormat,
            altInput: altInput,
            altFormat: altFormat,
        })
    });

    $('select.selectize').each(function () {
        var create = false;
        var delimiter = ',';
        var persist = false;
        var openOnFocus = true;
        var sortField = 'value';

        // TODO Change parameters to data-attributes
        if ($(this).hasClass('create')) {
            create = true;
        }

        if ($(this).hasClass('sort-index')) {
            sortField = [{
                field: 'index',
                direction: 'desc'
            }, {
                field: '$score'
            }];
        };

        if ($(this).hasClass('tag')) {
            openOnFocus = false;
            var modelid = $(this).data('model-id');
            create = function (input) {
                var url = 'tag/create';
                var slug = input.toLowerCase().replace(/ /g, '-').replace(/[-]+/g, '-').replace(/[^\w-]+/g, '');
                $.ajax({
                    'type': 'get',
                    'url': url,
                    'async': false,
                    'data': {
                        name: input,
                        slug: slug,
                        modelid: modelid,
                    }
                }).done(function (response) {
                    if (response.status === 201) {
                        console.log(response);
                        id = response.id;
                    } else {
                        console.log('ajaxerror', response);
                    }
                }).fail(function (response) {
                    console.log('ajaxerror', response);
                }).always(function (response) {
                    console.log('ajaxalways', response);
                });
                return {
                    value: id,
                    text: input
                };
            }
        }

        $(this).selectize({
            delimiter: delimiter,
            persist: persist,
            create: create,
            sortField: sortField,
            openOnFocus: openOnFocus
        });
    });

    // Form Builder
    $('.continue').on('click', function(e) {
        e.preventDefault();

        let $formId = $(this).data('form-id');

        let $overlay = $('.overlay');
        let $loader = $('.loading-ellipsis');

        $overlay.add($loader).addClass('loading');

        if ($('#form-review-' + $formId)[0].innerHTML.length > 0) {
            $.post('/custom_form/complete', {
                form_id: $formId
            }).then(resp => {
                $overlay.add($loader).removeClass('loading');
                $('#form-review-' + $formId).html('');
                $('#back-' + $formId + ', #save-' + $formId + ', #continue-' + $formId).hide();
                $('#success-' + $formId).show();
            });

            return false;
        }

        let formData = new FormData();
        let section_hidden = $('input[data-form-id=' + $formId + ']')[0];

        $(':input').removeClass('error');
        $('.form-error').remove();
        formData.append('section_id', section_hidden.value);

        $('[data-element-section-id=' + section_hidden.value + ']').each(function() {
            if (($(this).attr('type') != 'checkbox' && $(this).attr('type') != 'radio') || $(this).is(':checked')) {
                formData.append($(this).attr('name'), $(this).val());
            }

            if ($(this).hasClass('custom-form-upload')) {
                let api = $.fileuploader.getInstance($(this));
                let files = api.getChoosedFiles();

                files.forEach(value => {
                    formData.append($(this).attr('name'), value.file, value.name);
                });
            }
        });

        $.ajax({
            url: '/custom_form/validate',
            data: formData,
            type: 'POST',
            enctype: 'multipart/form-data',
            cache: false,
            contentType: false,
            processData: false,
            xhr: function() {
                var xhr = $.ajaxSettings.xhr();

                if (xhr.upload) {
                    xhr.upload.addEventListener('progress', this.progress, false);
                }

                return xhr;
            },
            success: resp => {
                $overlay.add($loader).removeClass('loading');

                if (resp.success === false) {
                    for (let key in resp.errors) {
                        let $el = $('[name="' + key + '"]');

                        if ($el.is(':checkbox')) {
                            $el.addClass('error').closest('.form-element').find('> div:first-child').after('<p class="form-error">' + resp.errors[key] + '</p>');
                        } else {
                            $('[name="' + key + '"]').addClass('error').after('<p class="form-error">' + resp.errors[key] + '</p>');
                        }
                    }
                } else {
                    $('.continue_form').hide();
                    $("#save-" + $formId).show();

                    // Add in the uploaded attribute to these files so that we know to delete them on the server if they're removed later
                    $('.custom-form-upload[data-element-section-id="' + section_hidden.value + '"]').each(function() {
                        let api = $.fileuploader.getInstance($(this));
                        let files = api.getChoosedFiles();

                        files.forEach(value => {
                            value.uploaded = true;
                            value.media_id = resp.uploads[value.name];
                        });
                    });


                    if (resp.review) {
                        // Redirect to Main Smaver Site
                        $(window.location = "https://smaver.com.au/smartlist-completed/");
                        //$('div[data-section-id="' + resp.final_section + '"]').hide();
                        //$('#form-review-' + resp.form_id).prepend('<h2>Review</h2><h3>Please review your document before submission</h3><dl class="review"></dl>');

                        //resp.results.forEach(value => {
                        //    $('#form-review-' + resp.form_id + ' dl').append(value);
                        //});

                        //$(this).html("Submit");
                    } else if (! resp.completed) {
                        $('.back').show();
                        $('.form-section').hide();
                        $('div[data-section-id="' + resp.next_section + '"]').show();
                        $('input[data-form-id="' + $formId + '"]').each(function() {
                            $(this).val(resp.next_section);
                        });
                    }

                    $('html, body').animate({
                        scrollTop: $('.cms-page').offset().top - parseInt($('.cms-page').css('marginTop'))
                    }, 500);
                }
            },
            progress: function(e) {
                if (e.lengthComputable) {
                    var t = Math.round(e.loaded * 100 / e.total).toString();

                    $('.form-status .progressbar .progress').css('width', t + '%');
                }
            }
        });
    });

    $('.back').on('click', function(e) {
        e.preventDefault();

        let $formId = $(this).data('form-id');
        let section_hidden = $('input[data-form-id="' + $formId + '"]')[0];

        let $overlay = $('.overlay');
        let $loader = $('.loading-ellipsis');

        $overlay.add($loader).addClass('loading');

        $.post('/custom_form/back', {
            section: section_hidden.value,
            review: $('#form-review-' + $formId)[0].innerHTML.length > 0
        }).then(resp => {
            $overlay.add($loader).removeClass('loading');

            $(".continue[data-form-id='" + $formId + "']").html("Continue");   //In case it's been changed to Submit
            $('#form-review-' + resp.form_id).html('');
            $('.form-section').hide();
            $('div[data-section-id="' + resp.previous + '"]').show();
            $('input[data-form-id="' + $formId + '"]').each(function() {
                $(this).val(resp.previous);
            });
            if (! resp.display) {
                $(this).hide();
            }
        });
    });

    $('.custom-form-upload').fileuploader({
        limit: 20,
        maxSize: 120,
        addMore: true,
        changeInput: '<div class="fileuploader-input">Click to upload</div>',
        thumbnails: {
            item:   '<li class="fileuploader-item file-has-popup">' +
                        '<div class="columns">' +
                            '<div class="column-thumbnail">${image}<span class="fileuploader-action-popup"></span></div>' +
                            '<div class="column-title">' +
                                '<div title="${name}">${name}</div>' +
                            '</div>' +
                            '<div class="column-actions">' +
                                '<a class="fileuploader-action fileuploader-action-remove" title="Remove"><i>Remove</i></a>' +
                            '</div>' +
                        '</div>' +
                        '<div class="progress-bar2">${progressBar}<span></span></div>' +
                    '</li>',
            item2: '<li class="fileuploader-item file-has-popup">' +
                        '<div class="columns">' +
                            '<div class="column-thumbnail"><img src="${data.url}" /><span class="fileuploader-action-popup"></span></div>' +
                            '<div class="column-title">' +
                                '<div title="${name}">${name}</div>' +
                            '</div>' +
                            '<div class="column-actions">' +
                                '<a class="fileuploader-action fileuploader-action-remove" title="Remove"><i>Remove</i></a>' +
                            '</div>' +
                        '</div>' +
                        '<div class="progress-bar2">${progressBar}<span></span></div>' +
                    '</li>',
        },
        theme: 'onebutton',
        upload: true,
        enableApi: true,
        onSelect: function(item) {
            // item.upload = null;
        },
        onRemove: function(item) {
            if (item.uploaded || item.data.uploaded) {
                $.post('/custom_form/remove_file', {
                    media: (item.media_id !== undefined ? item.media_id : item.data.media_id)
                });
            }
        }
    });

    $('[data-element-section-id]').on('change', function(e) {
        $.post('/custom_form/display_fields', {
            field: $(this).data('element'),
            value: $(this).val()
        }).then(resp => {
            resp.elements.forEach(value => {
                if (value.display == false) {
                    $('#form-element-' + value.element).hide();
                } else if (value.display == true) {
                    $('#form-element-' + value.element).show();
                }
            });
        });
    });

    $('[data-element-section-id]:checked').trigger('change');

    $('.save').on('click', function (e) {
        e.preventDefault();

        let $formId = $(this).data('form-id');

        let $overlay = $('.overlay');
        let $loader = $('.loading-ellipsis');

        $overlay.add($loader).addClass('loading');

        let formData = new FormData();
        let section_hidden = $('input[data-form-id=' + $formId + ']')[0];

        $(':input').removeClass('error');
        $('.form-error').remove();
        formData.append('section_id', section_hidden.value);

        $('[data-element-section-id=' + section_hidden.value + ']').each(function () {
            if (($(this).attr('type') != 'checkbox' && $(this).attr('type') != 'radio') || $(this).is(':checked')) {
                formData.append($(this).attr('name'), $(this).val());
            }

            if ($(this).hasClass('custom-form-upload')) {
                let api = $.fileuploader.getInstance($(this));
                let files = api.getChoosedFiles();

                files.forEach(value => {
                    formData.append($(this).attr('name'), value.file, value.name);
                });
            }
        });

        $.ajax({
            url: '/custom_form/validate',
            data: formData,
            type: 'POST',
            enctype: 'multipart/form-data',
            cache: false,
            contentType: false,
            processData: false,
            success: resp => {
                $overlay.add($loader).removeClass('loading');

                if (resp.success === false) {
                    for (let key in resp.errors) {
                        $('[name="' + key + '"]').addClass('error').after('<p class="form-error">' + resp.errors[key] + '</p>');
                    }
                } else {
                    $.post("/custom_form/save", { form_id: $formId })
                    .done(function(resp) {
                        if(resp.success) {
                            window.location = '/assignment';
                        }
                    });

                }
            }}
        )
    });
});

function thisURL(params) {
    var url,
        thisURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisURL, '/', 2));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisURL = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURL = thisURL.substring(0, (thisURL.indexOf('?') == -1) ? thisURL.length : thisURL.indexOf('?'));
        thisURL = thisURL.substring(0, getPosition(thisURL, '/', 2));
        url = thisURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function thisSubURL(params) {
    var url,
        thisSubURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('?') == -1) ? thisSubURL.length : thisSubURL.indexOf('?'));
        thisSubURL = thisSubURL.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisSubURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function getPosition(string, subString, index) {
   return string.split(subString, index).join(subString).length;
}
